namespace GeniuzPOS.Common.Helpers {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class DocFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.docTypePropertyId) {
                return text;
            }

            let docType = ctx.item[this.docTypePropertyId];
            
            if (docType == 1) {
                return "<i class='fa fa-file-text text-info'></i> " +
                       "<button class='btn btn-sm' style='background-color: #87CEEB; color: #4682B4; border: none;'>ใบกำกับภาษีขาย</button>";
            } else if (docType == 2) {
                return "<i class='fa fa-file-text-o text-warning'></i> " +
                       "<button class='btn btn-sm' style='background-color: #FFE4B5; color: #DAA520; border: none;'>ใบลดหนี้ขาย</button>";
            } else {
                return docType;
            }
        }

        @Serenity.Decorators.option()
        public docTypePropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.docTypePropertyId)
                column.referencedFields.push(this.docTypePropertyId);
        }
    }

}